import styled from "styled-components"; 

export const Margin = styled.div `
  margin: 40px; 
`